function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

/*
 * Kendo DropDownList with the popup anchored to a local positioned
 * wrapper — the body-portal anchor math lands the panel well below the
 * picker in this app's layout (see the dashboard period-selector fix).
 *
 * Props: options = [[value, label], ...] · value · onChange(value) · width
 */
export default class PlunkDropDown extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "setAnchor", el => {
      if (el && this._anchor !== el) {
        this._anchor = el;
        this.forceUpdate();
      }
    });
  }
  render() {
    const {
      options = [],
      value,
      onChange,
      width = "160px"
    } = this.props;
    const data = options.map(([v, label]) => ({
      value: v,
      label
    }));
    const current = data.find(d => d.value === value) || {
      value,
      label: String(value ?? "")
    };
    return /*#__PURE__*/React.createElement("div", {
      ref: this.setAnchor,
      style: {
        position: "relative",
        display: "inline-block"
      }
    }, /*#__PURE__*/React.createElement(DropDownList, {
      data: data,
      textField: "label",
      dataItemKey: "value",
      value: current,
      onChange: e => onChange(e.value.value),
      style: {
        width
      },
      popupSettings: this._anchor ? {
        appendTo: this._anchor
      } : undefined
    }));
  }
}